//////////////////////////////////////////////////////////
//                                                      //   
//  PARA TODOS OS USUÁRIOS:                             //   
//                                                      //   
//  APARECE COMO O CARD DE PRODUTOS                     //   
//  COMPRADOS NA PÁGINA DE CHECKOUT                     //   
//                                                      //   
//  FUNCIONALIDADE: MOSTRAR RESUMO DOS PRODUTOS         //
//    COMPRANDOS ANTES DO PAGAMENTO                     //    
//                                                      //   
//////////////////////////////////////////////////////////   



//////////////////////////////////////////////////////////////////////////
//                                                                      //
//  LISTA DE PÁGINAS E OUTROS COMPONENTES QUE UTILIZAM ESSE ARQUIVO:    //
//                                                                      //
//      frontend/src/pages/chekout.js                                   //
//                                                                      //
//////////////////////////////////////////////////////////////////////////



function ProdutosComprados(props){

    var preco_total = 0
    var itens = props.props
    var matriz = []
    for (var i = 0; i < itens.length; i++){  // PARA CADA PRODUTO DO PEDIDO
        // FORMATA O PRECO UNITÁRIO (FORMATO XX.Y PARA XX,YY)
        var chave = itens[i].id
        var info = itens[i][chave]

        var img = info.img
        var preco = info.preco.toString()

        var preco_lista = preco.split('.')
    
        if(preco_lista.length === 2){
            var cents = preco_lista[1]
            
            if(cents.length === 1){
                cents = cents + '0'
            }
            if(cents.length > 2){
                cents = cents.slice(0, 2)
            }
    
            preco_lista[1] = cents
        }
        else if (preco_lista.length === 1){
            cents = '00'
            preco_lista.push(cents)
        }
    
        var preco_final = preco_lista.join(',')
    
        // CALCULA E FORMATA O PREÇO TOTAL (FORMATO XX.Y PARA XX,YY)
        var carrinho = info.carrinho

        var preco_produto = parseFloat(info.preco)*parseInt(info.carrinho)
        
        var preco_produto_lista = preco_produto.toString().split('.')
    
        if(preco_produto_lista.length === 2){
            var cents_produto = preco_produto_lista[1]
            
            if(cents_produto.length === 1){
                cents_produto = cents_produto + '0'
            }
            if(cents_produto.length > 2){
                cents_produto = cents_produto.slice(0, 2)
            }
    
            preco_produto_lista[1] = cents_produto
        }
        else if (preco_produto_lista.length === 1){
            cents_produto = '00'
            preco_produto_lista.push(cents_produto)
        }
    
    
        var preco_produto_final = preco_produto_lista.join(',')        
        
        preco_total = preco_total + preco_produto    

        matriz.push([img, carrinho, preco_final, preco_produto_final])  // ADICIONA OS DADOS DO PRODUTO NA MATRIZ
    }

    // CALCULA E FORMATA A SOMATÓRIA DO PREÇO FINAL
    var preco_total_lista = preco_total.toString().split('.')
    
    if(preco_total_lista.length === 2){
        var cents_total = preco_total_lista[1]
        
        if(cents_total.length === 1){
            cents_total = cents_total + '0'
        }
        if(cents_total.length > 2){
            cents_total = cents_total.slice(0, 2)
        }

        preco_total_lista[1] = cents_total
    }
    else if (preco_total_lista.length === 1){
        cents_total = '00'
        preco_total_lista.push(cents_total)
    }    

    var preco_total_final = preco_total_lista.join(',')       

    return(  // RENDERIZA O CARD COM OS PRODUTOS, QUANTIDADES E PREÇOS
        <div> 
            <p class="preco verde montserrat mt-3 mb-0 pb-2 font-x-larger px-5 border-bottom">Produtos Comprados</p>

            <div class="border-bottom">
            {matriz.map((sublist) => (
                <div class="row col col-12 pr-0 pl-3 mx-0 item-carrinho">
                    <div class="col-md-2 col-3">
                        <img class='picture_carrinho ml-3 my-3' src={sublist[0]} alt="Avatar"></img>
                    </div>

                    <div class="col-md-10 col-9 my-4">
                        <div class="verde montserrat font-x-large px-2">Quantidade:    {sublist[1]}</div>
                        <div class="verde montserrat font-x-large px-2">Preço:    R$ {sublist[2]}</div>
                        <div class="verde montserrat font-x-large px-2">Subtotal:    R$ {sublist[3]}</div>
                    </div>

                </div>         
            ))}
            </div>

            <div class="preco_total col-12 my-3 pr-0 mr-0 pl-5 ml-5">
                Total:    R$ {preco_total_final}
            </div>

        </div>
    )
}

export default ProdutosComprados